import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { AcceptWorkInviteParams } from '@/features/work/api/accept-work-invite/request';
import { acceptWorkInvite } from '@/features/work/api/accept-work-invite/request';

export const useAcceptWorkInviteMutation = (
  settings?: MutationSettings<AcceptWorkInviteParams, typeof acceptWorkInvite>
) =>
  useMutation({
    mutationKey: ['AcceptWorkInvite'],
    mutationFn: ({ params, config }) =>
      acceptWorkInvite({
        params,
        config
      }),
    ...settings?.options
  });
